export default function RedAlertActivityFeedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.00012207" width="28" height="28" rx="14" fill="#FF388A" />
      <g clip-path="url(#clip0_5075_950)">
        <path
          d="M14 14.6564V10.0626"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.99 6.12512H11.01C10.9238 6.12505 10.8384 6.14197 10.7587 6.17491C10.6791 6.20784 10.6067 6.25615 10.5457 6.31708L6.31695 10.5458C6.25603 10.6068 6.20772 10.6792 6.17479 10.7588C6.14185 10.8385 6.12493 10.9239 6.125 11.0101V16.9902C6.12493 17.0764 6.14185 17.1617 6.17479 17.2414C6.20772 17.3211 6.25603 17.3935 6.31695 17.4545L10.5457 21.6832C10.6067 21.7441 10.6791 21.7924 10.7587 21.8253C10.8384 21.8583 10.9238 21.8752 11.01 21.8751H16.99C17.0762 21.8752 17.1616 21.8583 17.2413 21.8253C17.321 21.7924 17.3933 21.7441 17.4543 21.6832L21.683 17.4545C21.744 17.3935 21.7923 17.3211 21.8252 17.2414C21.8582 17.1617 21.8751 17.0764 21.875 16.9902V11.0101C21.8751 10.9239 21.8582 10.8385 21.8252 10.7588C21.7923 10.6792 21.744 10.6068 21.683 10.5458L17.4543 6.31708C17.3933 6.25615 17.321 6.20784 17.2413 6.17491C17.1616 6.14197 17.0762 6.12505 16.99 6.12512Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M14 18.5939C14.5437 18.5939 14.9844 18.1532 14.9844 17.6095C14.9844 17.0658 14.5437 16.6251 14 16.6251C13.4563 16.6251 13.0156 17.0658 13.0156 17.6095C13.0156 18.1532 13.4563 18.5939 14 18.5939Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5075_950">
          <rect width="21" height="21" fill="white" transform="translate(3.5 3.50012)" />
        </clipPath>
      </defs>
    </svg>
  );
}
